import { render, staticRenderFns } from "./TedsLauncherSettings.vue?vue&type=template&id=62a9e67b&"
import script from "./TedsLauncherSettings.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherSettings.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports